import { render, staticRenderFns } from "./ClaimExamSelect.vue?vue&type=template&id=08aca01c&"
import script from "./ClaimExamSelect.vue?vue&type=script&lang=js&"
export * from "./ClaimExamSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports